var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "__btn_input" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.toAddress,
            expression: "toAddress"
          }
        ],
        attrs: { placeholder: "toAddress" },
        domProps: { value: _vm.toAddress },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.toAddress = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLoading,
            expression: "!isLoading"
          }
        ],
        staticClass: "totop __btn __btn_all_in __pointer",
        on: { click: _vm.sendAllBalance }
      },
      [_vm._v("Send Tx (All balance)")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading"
          }
        ],
        staticClass: "totop __btn __btn_all_in __pointer"
      },
      [_vm._v("Sending...")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }